<script lang="ts">
  import { Label } from '$lib/components/ui/label';
  import { Input } from '$lib/components/ui/input';
  import { t } from '$lib/i18n';
  import type { StampColor } from '@briefmarken_katalog/types';

  let {
    value = $bindable<StampColor | undefined>(undefined),
    isReadonly = false,
  }: {
    value: StampColor | undefined;
    isReadonly?: boolean;
  } = $props();

  let isMultiColored = $state(value != null && 'isMultiColored' in value);
  let primary = $state(value != null && 'primary' in value ? value.primary : '');
  let secondary = $state(value != null && 'secondary' in value ? (value as { primary: string; secondary: string }).secondary : '');

  $effect(() => {
    if (isMultiColored) {
      value = { isMultiColored: true };
    } else if (primary) {
      value = secondary ? { primary, secondary } : { primary };
    } else {
      value = undefined;
    }
  });
</script>

<div class="grid grid-cols-4 items-center gap-4">
  <Label class="text-right">{$t('fields.color.label')}</Label>
  <div class="col-span-3 flex items-center gap-2">
    <input
      type="checkbox"
      bind:checked={isMultiColored}
      disabled={isReadonly}
      title={$t('fields.color.multiColored')}
      class="w-4 h-4 {isReadonly ? '' : 'cursor-pointer'}"
    />
    <Label class="whitespace-nowrap">{$t('fields.color.multiColored')}</Label>
    <Input
      disabled={isMultiColored || isReadonly}
      bind:value={primary}
      placeholder={$t('fields.color.primary')}
      class="flex-1"
    />
    <Input
      disabled={isMultiColored || !primary || isReadonly}
      bind:value={secondary}
      placeholder={$t('fields.color.secondary')}
      class="flex-1"
    />
  </div>
</div>
